<template>
    <layout-primary :title-text="titleText">
        <slot slot="titleAction"
              name="titleAction"
        />

        <slot slot="headerRight"
              name="search"
              :filter="filter"
              :filters="pageModel.filters"
        />

        <slot slot="headerContent"
              name="header"
        />

        <slot slot="notification"
              name="notification"
        />

        <slot slot="preContent"
              name="filters"
              :filter="filter"
              :sort="sort"
              :filters="pageModel.filters"
        />

        <scroll-view
            v-if="$mq === 'mobile' && pageModel.hasMobileView"
            id="mobile-view"
            :identifier="`mv-${pageModel.stateVersion}`"
            :data-provider="pageModel"
        >
            <template #item-tpl="{ listItem }">
                <slot name="mobile-item-tpl"
                      :list-item="listItem"
                />
            </template>
        </scroll-view>

        <base-table v-if="$mq !== 'mobile' || !pageModel.hasMobileView"
                    :fixed-header="pageModel.fixedHeader"
                    :row-uniq-id="pageModel.uniqueField"
                    :columns="pageModel.columns"
                    :rows="pageModel.table.items"
                    :default-sort="pageModel.table.order"
                    :actions="pageModel.actions"
                    :actions-always-visible="pageModel.actionsAlwaysVisible"
                    :dependencies="pageModel.dependencies"
                    :row-class="pageModel.rowClass"
                    :loading="pageModel.table.loading"
                    :actions-width="pageModel.actionsWidth"
                    @sort="sort"
        >
            <template v-for="(col) in pageModel.columns"
                      :slot="`column-${col.field}`"
                      slot-scope="slotData"
            >
                <slot :name="`column-${col.field}`"
                      v-bind="slotData"
                />
            </template>

            <template slot="column-default-tpl"
                      slot-scope="slotData"
            >
                <slot name="column-default-tpl"
                      v-bind="slotData"
                />
            </template>

            <template slot="column-actions-tpl"
                      slot-scope="slotData"
            >
                <slot name="column-actions-tpl"
                      v-bind="slotData"
                />
            </template>

            <slot slot="noData"
                  name="noData"
            />
        </base-table>

        <base-pagination
            v-if="$mq !== 'mobile'"
            slot="pagination"
            :current-page="pageModel.table.page"
            :results="pageModel.table.total"
            :items-per-page="pageModel.table.pageSize"
            :page-route="pageRoute"
            class="list-page__footer"
            @paging="paging"
        />
    </layout-primary>
</template>

<script>
import ScrollView from '@/components/layout/ScrollView';
import LayoutPrimary from '@/components/layout/LayoutPrimary';
import { BaseTable, BasePagination } from '@/components/table';

export default {
    name: 'ListPage',
    components: {
        LayoutPrimary,
        BaseTable,
        ScrollView,
        BasePagination,
    },
    props: {
        titleText: {
            type: String,
            required: true,
        },
        pageModel: {
            type: Object,
            required: true,
        },
        pageRoute: {
            type: String,
            default: '/',
        },
    },
    watch: {
        $mq(value) {
            this.prepareMobileView(value);
        },
    },
    mounted() {
        this.prepareMobileView(this.$mq);
        this.pageModel.restore();
    },
    methods: {
        paging(data) {
            this.pageModel.paging(data);
        },
        prepareMobileView(mq) {
            if (this.pageModel.toggleInfinityMode && this.pageModel.hasMobileView) {
                this.pageModel.toggleInfinityMode(mq === 'mobile');
            }
        },
        filter(field, value) {
            this.pageModel.filter(field, value);
        },
        sort(column, isSortAsc) {
            this.pageModel.sort(column, isSortAsc);
        },
    },
};
</script>
